import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patientsApi } from '../api/patients.api';
import { patientsQueryKey } from './usePatients';
import type { DetachPatientInput, DetachPatientResult } from '../types/patient.types';

/**
 * Removes a patient↔account association (`/v2/DetachPatient`). On success the
 * patient list is refreshed so the `attachedBy` note updates immediately.
 */
export function useDetachPatient() {
  const queryClient = useQueryClient();

  return useMutation<DetachPatientResult, Error, DetachPatientInput>({
    mutationKey: ['patients', 'detach'],
    mutationFn: (input) => patientsApi.detachPatient(input),
    onSuccess: (result) => {
      if (result.success) {
        void queryClient.invalidateQueries({ queryKey: patientsQueryKey });
      }
    },
  });
}
